import { defineStore } from 'pinia'
import { ChangeBackgroundPageList, MenuItems, ToolsPageData } from '~/static/types/tools'
import { toolsService } from '~/services/tools'

interface ToolsStore {
  changeBackgroundPageList: ChangeBackgroundPageList
  currentPageData: ToolsPageData | null
  isLoadingBackgrounds: boolean
  isPageLoading: boolean
  menuItems: MenuItems
}

export const useToolsStore = defineStore('tools', {
  state: (): ToolsStore => {
    return {
      changeBackgroundPageList: [],
      isLoadingBackgrounds: false,
      currentPageData: null,
      isPageLoading: false,
      menuItems: [],
    }
  },
  actions: {
    async getChangeBackgroundPageList() {
      this.isLoadingBackgrounds = true

      try {
        const data = await toolsService.getChangeBackgroundPageList()

        if (data) {
          this.changeBackgroundPageList = data
          return this.changeBackgroundPageList
        }
      } catch (error: unknown) {
        console.error('Ошибка при загрузке списка фонов:', error)
      } finally {
        this.isLoadingBackgrounds = false
      }
    },
    async getPageDataBySlug(slug: string) {
      this.isPageLoading = true
      this.currentPageData = null

      try {
        const data = await toolsService.getPageDataBySlug(slug)

        if (data) {
          this.currentPageData = data
          return data
        }
      } catch (error: unknown) {
        console.error('Ошибка при загрузке данных страницы инструмента:', error)
      } finally {
        this.isPageLoading = false
      }
    },
    async getMenuItems() {
      try {
        const data = await toolsService.getMenuItems()

        if (data) {
          this.menuItems = data
        }
      } catch (error: unknown) {
        console.error('Ошибка при загрузке пунктов меню:', error)
      }
    },
  },
})
